import { render, staticRenderFns } from "./article-form.vue?vue&type=template&id=4bbbc09c&scoped=true&"
import script from "./article-form.ts?vue&type=script&lang=ts&"
export * from "./article-form.ts?vue&type=script&lang=ts&"
import style0 from "./article-form.scss?vue&type=style&index=0&id=4bbbc09c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbbc09c",
  null
  
)

export default component.exports